import { lazy, useMemo } from 'react';

export const useLazyLoad = (pagePath: string) => {
   return useMemo(
      () =>
         lazy(
            () =>
               new Promise<any>((resolve) => {
                  setTimeout(() => {
                     resolve(import(`../pages/${pagePath}`));
                  }, 10);
               })
         ),
      [pagePath]
   );
};
